var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import { Participant } from './Participant';
import { Truncator } from 'packages/utilities/Truncator';
var Message = /** @class */ (function (_super) {
    __extends(Message, _super);
    function Message() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.subject = null;
        _this.body = null;
        _this.from = null;
        _this.sender = new Participant();
        _this.recipient = new Participant();
        _this.sentAt = null;
        _this.readAt = null;
        _this.createdAt = null;
        _this.asCompany = false;
        return _this;
    }
    Object.defineProperty(Message.prototype, "truncatedBody", {
        /**
         * Returns the body truncated with markup removed
         *
         * @readonly
         *
         * @memberOf Message
         */
        get: function () {
            return Truncator.stripMarkupAndTruncate(this.body);
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b;
    __decorate([
        Type(Object),
        __metadata("design:type", Object)
    ], Message.prototype, "from", void 0);
    __decorate([
        Type(Participant),
        __metadata("design:type", typeof (_a = typeof Participant !== "undefined" && Participant) === "function" ? _a : Object)
    ], Message.prototype, "sender", void 0);
    __decorate([
        Type(Participant),
        __metadata("design:type", typeof (_b = typeof Participant !== "undefined" && Participant) === "function" ? _b : Object)
    ], Message.prototype, "recipient", void 0);
    return Message;
}(Entity));
export { Message };
